module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/experiences/spaces/03_05_atdawn.png";